export interface IViewTypeOption {
  /** The identity: matches the API ViewType enum description and is what gets persisted. */
  value: string;
  labelKey: string;
}

export const DEFAULT_VIEW_TYPE = "default";

/**
 * Patient page card ordering view types (EN-4972). Only `labelKey` is language-dependent —
 * `value` is what `updateSelectedViewType` sends and what the saved preference holds (EN-5191).
 */
export const viewTypeOptions: IViewTypeOption[] = [
  { value: DEFAULT_VIEW_TYPE, labelKey: "viewType_default" },
  { value: "cardiac", labelKey: "viewType_cardiac" },
  { value: "maternity", labelKey: "viewType_maternal" },
  { value: "renal", labelKey: "viewType_renal" },
  { value: "endocrinology", labelKey: "viewType_endocrinology" },
  { value: "respiratory", labelKey: "viewType_respiratory" },
];
